var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIdSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 49,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 496,
    width: 61,
    height: 49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.410596,
    y: -9525.93,
    width: 590632,
    height: 485843
  })), /*#__PURE__*/React.createElement("image", {
    width: 97,
    height: 78,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 580496,
    height: 466791
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-448 -496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000104972 0 0 0.000104972 448 496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    transform: "matrix(1.00105 0 0 1 -0.27178 -0.0563455)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(5984.5 5984.5)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdSign);
export default __webpack_public_path__ + "static/media/ID_Sign.da1b82748bb0a2a8397b5ff7bc0b6b25.svg";
export { ForwardRef as ReactComponent };